import React from 'react'

const VenueCard = ({ venue }) => {
  return (
    <div className="bg-white/5 rounded-lg p-3 border border-white/10">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-white font-medium">{venue.venueName}</div>
          <div className="text-gray-300 text-sm">{venue.country}</div>
        </div>
        <div className="text-right">
          <div className="text-white font-medium">
            {venue.events.length} time{venue.events.length > 1 ? 's' : ''}
          </div>
          <div className="text-gray-400 text-sm">
            {venue.events.map(event => new Date(event.startDate).getFullYear()).join(', ')}
          </div>
        </div>
      </div>
      <div className="mt-2">
        {venue.events.map((event, eventIndex) => (
          <div key={eventIndex} className="text-xs text-gray-400">
            📅 {event.eventName} - {new Date(event.startDate).toLocaleDateString()}
          </div>
        ))}
      </div>
    </div>
  )
}

export default VenueCard